<script setup lang="ts">
	import { useBasePrinter } from './BasePrinter.js';
	import {ref} from 'vue';
	
	const props = defineProps({
		value: String,
		style: String,
		styleClass: String,
		sortStyle: Object,
		rowValue: String
	});
		
	const {tdStyle} = useBasePrinter(props);
	const emit = defineEmits(['openFolder']);

	/*function printValue(value): string {	
		if (value) {
			return value.replaceAll("&quot;", "\"").replaceAll("&hellip;", "...");
		}
		else {
			return "";
		}
	}*/
</script>
<template> 
	<td :class="styleClass" :style="[sortStyle, tdStyle]">
		<a href="#" @click.prevent="$emit('openFolder')" v-html="value"></a>
	</td>
</template>

